import { Spinner } from "react-bootstrap";

export function Loading({ label = "読み込み中..." }: { label?: string }) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5 text-secondary">
      <Spinner animation="border" role="status" />
      <span className="mt-2">{label}</span>
    </div>
  );
}
